<i18n>
{
    "en_US": {
        "label": "New password"
    },
    "fr_FR": {
        "label": "Nouveau mot de passe"
    }
}
</i18n>

<template>
    <div class="input-group mb-3 bmd-form-group">
        <label for="inputNewPassword" class="bmd-label-floating" v-text="$t('label')"></label>
        <input v-if="!reveal" id="inputNewPassword" type="password" class="form-control bmb-control" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" v-bind:disabled="disabled" required />
        <input v-else id="inputNewPassword" type="text" class="form-control bmb-control" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" v-bind:disabled="disabled" required />
        <div class="input-group-append">
            <a class="input-group-text" id="basic-addon2" v-on:click="toggle">
                <i v-if="!reveal"  class="far fa-eye"></i>
                <i v-else class="far fa-eye-slash"></i>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PasswordReveal",
        props: {
            value: String,
            disabled: Boolean
        },
        data: function() {
            return {
                reveal: false
            };
        },
        methods: {
            toggle: function() {
                this.reveal = !this.reveal;
            }
        }
    }
</script>

<style scoped>
    input {
        border-right: 0;
    }
    label {
        font-weight: bold;
        font-size: 14px;
    }
    a {
        cursor: pointer;
        background-color: #fff;
        border-left: 0;
        padding-left: 5px;
    }
    i {
        color: #949ba1;
    }
</style>